define('model-collections/review',['underscore', 'backbone', 'classes/templator'],
  function(_, Backbone, templator) {

    var Review = {};

    Review.Model = Backbone.Model.extend({

      defaults: {
        rendered: false
      },

      getRating: function() {
        var ret = null;
        if (this.get('rating')) {
          ret = Math.round(this.get('rating')) / 2;
        }
        return ret;
      }

    });

    Review.Collection = Backbone.Collection.extend({
      model: Review.Model,
      url: '/restaurant/:restaurant_id/reviews',

      initialize: function(restaurant_id) {
        if (parseInt(restaurant_id) == restaurant_id) {
          this.restaurant_id = restaurant_id;
          this.url = this.url.replace(/:restaurant_id/, this.restaurant_id);
          this.reviews = null;
        }
      }

    });

    Review.View = Backbone.View.extend({

      events: {
        'click #re-reviews': 'fetchReviews'
      },

      initialize: function(options) {
        this.restaurant_id = options.restaurant_id;
      },

      template: templator.reviews,

      fetchReviews: function(e) {
        $(e.target).blur();
        var this_ = this;
        if (!this.reviews) {
          this.reviews = new Review.Collection(this.restaurant_id);
          var $loading = this.$el.find('.loading');
          $loading.removeClass('hidden');
          this.reviews.fetch({
            success: function (reviews, response, options) {
              this_.render();
              $loading.addClass('hidden');
            },
          });
        }
      },

      render: function() {
        this.$el.find('.loading').after(this.template({reviews: this.reviews.models}));
      }

    });

    return Review;
  }
);
